import { Panels } from "@msuite/ui/panels";
import { AttendancesChart } from "@/components/attendances/attendances-chart";
import Notes from "@/components/notes";
import type { UserPanelBaseProps } from "../types";
import { UserEmployment } from "../user-employment";
import { UserIntegrations } from "./user-integrations";

export function UserGeneral({ userId }: UserPanelBaseProps) {
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<UserEmployment userId={userId} />
				<AttendancesChart userId={userId} />
				<UserIntegrations userId={userId} />
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<Notes
					notesTable="userNotes"
					identifier={userId}
				/>
			</Panels.Panel>
		</Panels>
	);
}
